import { action, makeAutoObservable, observable } from 'mobx';
import {
  DistrictState,
  FieldOption,
  QuantityValue,
} from '@project/components/Module/StatisticMenu/types';
import { StatisticMenuController } from '@project/store/StatisticMenuController';

export type FieldOptionState = FieldOption & { value: string | number | null };

export class StatisticViewController {
  @observable public comparison: boolean = false;
  @observable public fieldOptions: FieldOptionState[] = [];
  @observable public district: DistrictState | null = null;
  @observable public comparisonDistrict: DistrictState | null = null;
  @observable public quantity: QuantityValue = 'count';
  menuState: StatisticMenuController;

  constructor(menuState: StatisticMenuController) {
    makeAutoObservable(this);

    this.menuState = menuState;
  }

  @action
  setFieldOptions(fields: FieldOptionState[]) {
    this.fieldOptions = fields;
  }

  @action
  setComparison(value: boolean) {
    this.comparison = value;
    this.district = null;
    this.comparisonDistrict = null;
  }

  @action
  setDistrict(value: DistrictState | null) {
    this.district = value;
  }

  @action
  setComparisonDistrict(value: DistrictState | null) {
    this.comparisonDistrict = value;
  }

  @action
  setQuantity(value: QuantityValue) {
    this.quantity = value;
  }

  @action
  clearFields() {
    this.fieldOptions = [];
    this.comparison = false;
    this.district = null;
    this.comparisonDistrict = null;
  }
}
